import { render, staticRenderFns } from "./TableTotalPerPage.vue?vue&type=template&id=764cb30b&scoped=true&"
import script from "./TableTotalPerPage.vue?vue&type=script&lang=js&"
export * from "./TableTotalPerPage.vue?vue&type=script&lang=js&"
import style0 from "./TableTotalPerPage.vue?vue&type=style&index=0&id=764cb30b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764cb30b",
  null
  
)

export default component.exports